import { useDedupEffect } from "hooks"
import { LoadingProps } from "../Types/ViewTypes";
import { useDispatch, useSelector } from "react-redux";
import { IADPState } from "Types/AppStateTypes";
import { useDeviceValidationService } from "hooks/useDeviceValidationService";
import { LoadingView } from "./LoadingView";
import HeartbeatService from "services/heartBeatService";
import { ScreenDialogue } from "lib/components";
import { useState } from "react";
import { createSetConfirmationModalAction, createSetViewAction } from "state/reducer";
import { useRedirectionService } from "hooks/useRedirectionService";


export const DeviceValidationLoadingView = () => { 
    const state = useSelector((state:{rootState:IADPState})=>state.rootState)
    const {performDeviceValidation} = useDeviceValidationService()
    const dispatch = useDispatch();
    const [, setDisabled] = useState(true);
    const {redirectToSCI} = useRedirectionService()

    const loadingProps: LoadingProps = {
        title: state.currentLanguageContent?.deviceValidationWait.title || "",
        message: state.currentLanguageContent?.deviceValidationWait.message || "",
        subTitle:state.currentLanguageContent?.deviceValidationWait.subTitle || "",
    };
  useDedupEffect(()=>{
    performDeviceValidation('online');
    HeartbeatService.init(state);
  },[])  

  const cancelConfirmationModal = () => {
    dispatch(createSetConfirmationModalAction(false));
    dispatch(createSetViewAction("AccessCodeValidationView"))
    setDisabled(false);
  }

  const submitConfirmationModal = () => {
    redirectToSCI();
  }

  return (
    <>
      <LoadingView {...loadingProps} />
      {(state.sessionState.confirmationModal && state.sessionState.appAccessedFor == 'Assess') && (
        <>
          <ScreenDialogue
            title={state.currentLanguageContent?.accessCode.confirmationModal.title || ""}
            subTitle={state.sessionState?.schoolDetails?.location}
            confirmText={state.currentLanguageContent?.accessCode.confirmationModal.confirmText || ""}
            cancelText={state.currentLanguageContent?.accessCode.confirmationModal.cancelText || ""}
            onCancelAction={cancelConfirmationModal}
            onSubmitAction={submitConfirmationModal}
          ></ScreenDialogue>
        </>
      )}
    </>

  )
}